var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _rect, _polygon2, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.68 79.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3c3c3c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u534E\u52E4logo_\u7070\u8272 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.28,58.94a27.82,27.82,0,1,0,27.81,27.81A27.82,27.82,0,0,0,132.28,58.94Zm0,46a18.21,18.21,0,1,1,18.2-18.21A18.21,18.21,0,0,1,132.28,105Z",
    transform: "translate(-58.56 -58.94)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.33,114.57H62.81V58.94h9.63v51.14C72.44,115,68.33,114.57,68.33,114.57Z",
    transform: "translate(-58.56 -58.94)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.65,114.57H97.13V58.94h9.63v51.14C106.76,115,102.65,114.57,102.65,114.57Z",
    transform: "translate(-58.56 -58.94)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.8,105.52a28.15,28.15,0,0,1-8.9,6.51c.84.82,1.67,1.67,2.48,2.54h13.86A81.17,81.17,0,0,0,152.8,105.52Z",
    transform: "translate(-58.56 -58.94)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.77,99a76.55,76.55,0,0,0-87.21-7.54v1.17a82.19,82.19,0,0,1,76.83,12.08A18.17,18.17,0,0,0,145.77,99Z",
    transform: "translate(-58.56 -58.94)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.19 79.35 7.19 72.16 15.8 72.16 15.8 79.35 18.67 79.35 18.67 63.89 15.8 63.89 15.8 70.2 7.19 70.2 7.19 63.89 4.33 63.89 4.33 79.35 7.19 79.35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.48,122.83v8.75a5.81,5.81,0,0,1-1,3.68,4.7,4.7,0,0,1-3.34,1.18,4.29,4.29,0,0,1-3.38-1.18c-.37-.37-1-1.45-1-3.68v-8.75H82V132a9.75,9.75,0,0,0,.38,2.81,4.82,4.82,0,0,0,1.23,2.09,5.6,5.6,0,0,0,2.24,1.3,12.93,12.93,0,0,0,6.69,0,5.6,5.6,0,0,0,2.24-1.3A4.82,4.82,0,0,0,96,134.79a9.41,9.41,0,0,0,.38-2.81v-9.15Z",
    transform: "translate(-58.56 -58.94)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.05,138.29l1.35-3.54h7.67l1.38,3.54h3L109,122.83h-3.4l-6.49,15.46Zm5.17-12.88,3.09,7.39h-6.15Z",
    transform: "translate(-58.56 -58.94)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.56,
    y: 63.89,
    width: 2.87,
    height: 15.46
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.07 79.35 90.07 67.72 98.84 79.35 101.54 79.35 101.54 63.89 98.81 63.89 98.81 75.52 90.12 63.89 87.37 63.89 87.37 79.35 90.07 79.35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.85,136h-3.17a7.87,7.87,0,0,0,2.3-5.55,8.56,8.56,0,1,0-8.55,8.15c.25,0,.49,0,.73,0h8.69Zm-14.93-5.55A5.52,5.52,0,1,1,126,136a1.49,1.49,0,0,1-.37,0h-.43A5.56,5.56,0,0,1,119.92,130.47Z",
    transform: "translate(-58.56 -58.94)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHqLogo);
export default __webpack_public_path__ + "static/media/HQ_Logo.7aefe3d5a868d517eee5aab8f70eb572.svg";
export { ForwardRef as ReactComponent };